export const SET_LANGUAGE = 'SET_LANGUAGE'

interface ISetLanguage {
  readonly type: typeof SET_LANGUAGE;
  readonly payload: string;
}

export type TLanguageActions = ISetLanguage;
